module.exports = __webpack_public_path__ + "images/panorama-360-9a2204978e78080626efeaa9420afd72.svg";